import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { UserAddEdit, UserFiltering ,UserPasswordChange} from './Pages';

export const UserRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={UserFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={UserAddEdit} />
        <Route exact path={`${match.path}/userPasswordChange`} component={UserPasswordChange} />
    </Fragment>
)